import { useEffect, useRef } from "react";

// Note: this does not work for IE and older firefox versions
const useDownload = () => {
  const ref = useRef<HTMLAnchorElement>();
  useEffect(() => {
    ref.current = document.createElement("a");
    ref.current.target = "_blank";
  }, []);

  const download = (url: string, filename?: string) => {
    if (ref.current) {
      ref.current.href = url;
      if (filename) {
        ref.current.download = filename;
      }
      ref.current.click();
    }
  };

  return {
    download,
  };
};

export default useDownload;
